// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { AiFormAepFragmentDoc } from '../../../../components/formFields/ai/utils/aiProposalForm.generated';
import { PotentialOperationDetailsFragmentDoc } from '../../../../queries/fragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanPackageLocationsV2QueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type PlanPackageLocationsV2Query = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, roomLocations: Array<{ __typename?: 'ReadyPlanLocation', id: string, roomNumber?: number | null | undefined, fullRoomNumber?: number | null | undefined, marketingName: string, relatedTakeoffLineItemsCount: number, level?: { __typename?: 'Location', id: string, name: string } | null | undefined, location: { __typename?: 'Location', id: string, name: string }, roomType?: { __typename?: 'RoomType', id: string } | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean }>, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, readyPlan:
        | { __typename?: 'ReadyPlan', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
        | { __typename?: 'PlanPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
        | { __typename?: 'DesignPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
        | { __typename?: 'ProductOffering', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
       }>, aiProposal?: { __typename?: 'PlanPackageAiProposal', id: string, hasLocationProposals: boolean, entityProposals: Array<{ __typename?: 'AiEntityProposal', id: string, type: { __typename?: 'AiEntityProposalTypeDetail', code: Types.AiEntityProposalType }, entity?:
          | { __typename: 'MaterialListing', id: string }
          | { __typename: 'MaterialVariant', id: string }
          | { __typename: 'ReadyPlanLocation', id: string }
          | { __typename: 'ReadyPlanOption', id: string }
          | { __typename: 'ReadyPlanProgramData', id: string }
         | null | undefined, fieldProposals: Array<{ __typename?: 'AiFieldProposal', id: string, fieldName: string, fieldValue?: string | null | undefined, parentType: Types.AiEntityProposalType, status: { __typename?: 'AiFieldProposalStatusDetail', code: Types.AiFieldProposalStatus } }> }> } | null | undefined }, levels: Array<{ __typename?: 'Location', id: string, name: string, parent?: { __typename?: 'Location', id: string } | null | undefined }>, roomTypes: Array<{ __typename?: 'RoomType', id: string, name: string }> };

export type SavePlanPackageLocationsV2MutationVariables = Types.Exact<{
  inputs: Array<Types.SaveReadyPlanLocationInput> | Types.SaveReadyPlanLocationInput;
}>;


export type SavePlanPackageLocationsV2Mutation = { __typename?: 'Mutation', saveReadyPlanLocations: { __typename?: 'SaveReadyPlanLocationBulkResult', readyPlanLocations: Array<{ __typename?: 'ReadyPlanLocation', id: string, roomNumber?: number | null | undefined, fullRoomNumber?: number | null | undefined, marketingName: string, relatedTakeoffLineItemsCount: number, level?: { __typename?: 'Location', id: string, name: string } | null | undefined, location: { __typename?: 'Location', id: string, name: string }, roomType?: { __typename?: 'RoomType', id: string } | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean }>, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, readyPlan:
        | { __typename?: 'ReadyPlan', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
        | { __typename?: 'PlanPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
        | { __typename?: 'DesignPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
        | { __typename?: 'ProductOffering', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
       }>, readyPlans: Array<
      | { __typename?: 'ReadyPlan', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
      | { __typename?: 'PlanPackage', id: string, aiProposal?: { __typename?: 'PlanPackageAiProposal', id: string, hasLocationProposals: boolean, entityProposals: Array<{ __typename?: 'AiEntityProposal', id: string, type: { __typename?: 'AiEntityProposalTypeDetail', code: Types.AiEntityProposalType }, entity?:
              | { __typename: 'MaterialListing', id: string }
              | { __typename: 'MaterialVariant', id: string }
              | { __typename: 'ReadyPlanLocation', id: string }
              | { __typename: 'ReadyPlanOption', id: string }
              | { __typename: 'ReadyPlanProgramData', id: string }
             | null | undefined, fieldProposals: Array<{ __typename?: 'AiFieldProposal', id: string, fieldName: string, fieldValue?: string | null | undefined, parentType: Types.AiEntityProposalType, status: { __typename?: 'AiFieldProposalStatusDetail', code: Types.AiFieldProposalStatus } }> }> } | null | undefined, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
      | { __typename?: 'DesignPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
      | { __typename?: 'ProductOffering', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
    > } };

export type PlanPackageLocationProposalStatusFragment = { __typename?: 'AiFieldProposal', id: string, status: { __typename?: 'AiFieldProposalStatusDetail', code: Types.AiFieldProposalStatus } };

export type PlanPackageLocationsV2_PlanPackageFragment = { __typename?: 'PlanPackage', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, roomLocations: Array<{ __typename?: 'ReadyPlanLocation', id: string, roomNumber?: number | null | undefined, fullRoomNumber?: number | null | undefined, marketingName: string, relatedTakeoffLineItemsCount: number, level?: { __typename?: 'Location', id: string, name: string } | null | undefined, location: { __typename?: 'Location', id: string, name: string }, roomType?: { __typename?: 'RoomType', id: string } | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean }>, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, readyPlan:
      | { __typename?: 'ReadyPlan', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
      | { __typename?: 'PlanPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
      | { __typename?: 'DesignPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
      | { __typename?: 'ProductOffering', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
     }>, aiProposal?: { __typename?: 'PlanPackageAiProposal', id: string, hasLocationProposals: boolean, entityProposals: Array<{ __typename?: 'AiEntityProposal', id: string, type: { __typename?: 'AiEntityProposalTypeDetail', code: Types.AiEntityProposalType }, entity?:
        | { __typename: 'MaterialListing', id: string }
        | { __typename: 'MaterialVariant', id: string }
        | { __typename: 'ReadyPlanLocation', id: string }
        | { __typename: 'ReadyPlanOption', id: string }
        | { __typename: 'ReadyPlanProgramData', id: string }
       | null | undefined, fieldProposals: Array<{ __typename?: 'AiFieldProposal', id: string, fieldName: string, fieldValue?: string | null | undefined, parentType: Types.AiEntityProposalType, status: { __typename?: 'AiFieldProposalStatusDetail', code: Types.AiFieldProposalStatus } }> }> } | null | undefined };

export type PlanPackageLocationsV2_LocationFragment = { __typename?: 'ReadyPlanLocation', id: string, roomNumber?: number | null | undefined, fullRoomNumber?: number | null | undefined, marketingName: string, relatedTakeoffLineItemsCount: number, level?: { __typename?: 'Location', id: string, name: string } | null | undefined, location: { __typename?: 'Location', id: string, name: string }, roomType?: { __typename?: 'RoomType', id: string } | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean }>, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, readyPlan:
    | { __typename?: 'ReadyPlan', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
    | { __typename?: 'PlanPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
    | { __typename?: 'DesignPackage', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
    | { __typename?: 'ProductOffering', id: string, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
   };

export const PlanPackageLocationProposalStatusFragmentDoc = gql`
    fragment PlanPackageLocationProposalStatus on AiFieldProposal {
  id
  status {
    code
  }
}
    `;
export const PlanPackageLocationsV2_LocationFragmentDoc = gql`
    fragment PlanPackageLocationsV2_Location on ReadyPlanLocation {
  id
  roomNumber
  fullRoomNumber
  marketingName
  level {
    id
    name
  }
  location {
    id
    name
  }
  roomType {
    id
  }
  relatedTakeoffLineItemsCount
  readyPlanOptions {
    id
    active
  }
  canDelete {
    ...PotentialOperationDetails
  }
  readyPlan {
    id
    aggregateDraft {
      id
    }
  }
}
    ${PotentialOperationDetailsFragmentDoc}`;
export const PlanPackageLocationsV2_PlanPackageFragmentDoc = gql`
    fragment PlanPackageLocationsV2_PlanPackage on PlanPackage {
  id
  version {
    id
  }
  aggregateDraft {
    id
  }
  canEdit {
    ...PotentialOperationDetails
  }
  roomLocations {
    ...PlanPackageLocationsV2_Location
  }
  aiProposal {
    id
    hasLocationProposals
    entityProposals(entityType: [READY_PLAN_LOCATION]) {
      ...AiFormAep
    }
  }
}
    ${PotentialOperationDetailsFragmentDoc}
${PlanPackageLocationsV2_LocationFragmentDoc}
${AiFormAepFragmentDoc}`;
export const PlanPackageLocationsV2Document = gql`
    query PlanPackageLocationsV2($id: ID!, $versionId: ID!) {
  planPackage(id: $id, versionId: $versionId) {
    ...PlanPackageLocationsV2_PlanPackage
  }
  levels: locations(filter: {type: [LEVEL], version: [2]}) {
    id
    name
    parent {
      id
    }
  }
  roomTypes {
    id
    name
  }
}
    ${PlanPackageLocationsV2_PlanPackageFragmentDoc}`;

/**
 * __usePlanPackageLocationsV2Query__
 *
 * To run a query within a React component, call `usePlanPackageLocationsV2Query` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackageLocationsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackageLocationsV2Query({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function usePlanPackageLocationsV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<PlanPackageLocationsV2Query, PlanPackageLocationsV2QueryVariables> & ({ variables: PlanPackageLocationsV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackageLocationsV2Query, PlanPackageLocationsV2QueryVariables>(PlanPackageLocationsV2Document, options);
      }
export function usePlanPackageLocationsV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackageLocationsV2Query, PlanPackageLocationsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackageLocationsV2Query, PlanPackageLocationsV2QueryVariables>(PlanPackageLocationsV2Document, options);
        }
// @ts-ignore
export function usePlanPackageLocationsV2SuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageLocationsV2Query, PlanPackageLocationsV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageLocationsV2Query, PlanPackageLocationsV2QueryVariables>;
export function usePlanPackageLocationsV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageLocationsV2Query, PlanPackageLocationsV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageLocationsV2Query | undefined, PlanPackageLocationsV2QueryVariables>;
export function usePlanPackageLocationsV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageLocationsV2Query, PlanPackageLocationsV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackageLocationsV2Query, PlanPackageLocationsV2QueryVariables>(PlanPackageLocationsV2Document, options);
        }
export type PlanPackageLocationsV2QueryHookResult = ReturnType<typeof usePlanPackageLocationsV2Query>;
export type PlanPackageLocationsV2LazyQueryHookResult = ReturnType<typeof usePlanPackageLocationsV2LazyQuery>;
export type PlanPackageLocationsV2SuspenseQueryHookResult = ReturnType<typeof usePlanPackageLocationsV2SuspenseQuery>;
export type PlanPackageLocationsV2QueryResult = ApolloReactCommon.QueryResult<PlanPackageLocationsV2Query, PlanPackageLocationsV2QueryVariables>;
export const SavePlanPackageLocationsV2Document = gql`
    mutation SavePlanPackageLocationsV2($inputs: [SaveReadyPlanLocationInput!]!) {
  saveReadyPlanLocations(inputs: $inputs) {
    readyPlanLocations {
      ...PlanPackageLocationsV2_Location
    }
    readyPlans {
      id
      aggregateDraft {
        id
      }
      ... on PlanPackage {
        id
        aiProposal {
          id
          hasLocationProposals
          entityProposals(entityType: [READY_PLAN_LOCATION]) {
            ...AiFormAep
          }
        }
      }
    }
  }
}
    ${PlanPackageLocationsV2_LocationFragmentDoc}
${AiFormAepFragmentDoc}`;

/**
 * __useSavePlanPackageLocationsV2Mutation__
 *
 * To run a mutation, you first call `useSavePlanPackageLocationsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePlanPackageLocationsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePlanPackageLocationsV2Mutation, { data, loading, error }] = useSavePlanPackageLocationsV2Mutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSavePlanPackageLocationsV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePlanPackageLocationsV2Mutation, SavePlanPackageLocationsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePlanPackageLocationsV2Mutation, SavePlanPackageLocationsV2MutationVariables>(SavePlanPackageLocationsV2Document, options);
      }
export type SavePlanPackageLocationsV2MutationHookResult = ReturnType<typeof useSavePlanPackageLocationsV2Mutation>;
export type SavePlanPackageLocationsV2MutationResult = ApolloReactCommon.MutationResult<SavePlanPackageLocationsV2Mutation>;